<div class="farm-files" [nbSpinner]="isLoading">
  <!-- Upload drop zone -->
  <div *ngIf="canEdit" class="drop-zone" [class.drag-over]="isDragOver" [class.uploading]="isUploading"
    (dragover)="onDragOver($event)" (dragleave)="isDragOver = false" (drop)="onDrop($event)"
    (click)="fileInput.click()">
    <input #fileInput type="file" multiple hidden (change)="onFilesSelected($event)">
    <ng-container *ngIf="!isUploading; else uploadingTpl">
      <fa-icon [icon]="faUpload" size="lg"></fa-icon>
      <div class="drop-title">Drop files here or click to upload</div>
      <div class="drop-sub">Images, PDFs, Excel sheets, and more</div>
    </ng-container>
    <ng-template #uploadingTpl>
      <mat-spinner [diameter]="28"></mat-spinner>
      <div class="drop-title">Uploading…</div>
    </ng-template>
  </div>

  <!-- Type filter chips -->
  <div class="filter-chips" *ngIf="files.length > 0">
    <button type="button" class="chip" *ngFor="let f of filters" [class.active]="filter === f.key"
      [hidden]="f.key !== 'all' && count(f.key) === 0" (click)="filter = f.key">
      {{f.label}} <span class="chip-count">{{count(f.key)}}</span>
    </button>
  </div>

  <div *ngIf="!isLoading && files.length === 0" class="empty-state">
    No files yet.<span *ngIf="canEdit"> Upload one above.</span>
  </div>

  <!-- File tiles -->
  <div class="file-grid">
    <div class="file-tile" *ngFor="let file of filteredFiles" (click)="open(file)" [matTooltip]="file.fileName">
      <div class="file-preview" [ngSwitch]="kind(file)">
        <img *ngSwitchCase="'image'" [src]="'data:image/jpeg;base64,' + file.thumbnail" [alt]="file.fileName"
          [hidden]="!file.thumbnail">
        <fa-icon *ngSwitchCase="'pdf'" class="icon-pdf" [icon]="faFilePdf"></fa-icon>
        <fa-icon *ngSwitchCase="'excel'" class="icon-excel" [icon]="faFileExcel"></fa-icon>
        <fa-icon *ngSwitchDefault class="icon-other" [icon]="faFile"></fa-icon>
      </div>
      <div class="file-name">{{file.fileName}}</div>
      <div class="file-date">{{file.createdDate | date:'MMM d, y'}}</div>
      <button *ngIf="canEdit" type="button" class="delete-btn" matTooltip="Delete" (click)="confirmDelete(file, $event)">
        <fa-icon [icon]="faTrash" size="sm"></fa-icon>
      </button>
    </div>
  </div>
</div>
